import React from "react";
import TablesList from "./TablesList/TablesList";
import { inject, observer } from "mobx-react";
import { ISearchStore } from "@src/Stores/Search/types";

interface IProps {
  search?: ISearchStore;
}

@inject("search")
@observer
export default class FilteredTables extends React.Component<IProps> {
  render() {
    return this.props.search.entitiesLoaded ? <TablesList /> : null;
  }
}
